// Types and Interfaces
export interface ColumnDefinition {
  field: string;
  headerName: string;
  width?: number;
  flex?: number;
  minWidth?: number;
  textAlign?: "left" | "center" | "right";
  textTransform?: "capitalize" | "uppercase" | "lowercase" | "none";
}

export interface RowData {
  [key: string]: any;
}

export interface GridData {
  columns: ColumnDefinition[];
  rows?: RowData[];
  name: string;
}

// Sample Data
export const sampleData: GridData = {
  columns: [
    { field: "COLORCODE", headerName: "Color Code", width: 120 },
    { field: "NAME", headerName: "Name", width: 200 },
    { field: "EMAIL", headerName: "Email", width: 200 },
    {
      field: "CONTACTNO",
      headerName: "Contact Number",
      width: 200,
    },
    {
      field: "DATE",
      headerName: "Schedule Date",
      width: 200,
    },
    { field: "TIME", headerName: "Start Time", width: 200 },
    {
      field: "AMOUNT",
      headerName: "Amount",
      width: 200,
      textAlign: "right",
      textTransform: "capitalize",
    },
  ],
  rows: [
    {
      field: 1,
      COLORCODE: "#FFFFE0",
      NAME: "Roberto Carlos",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
    {
      field: 2,
      COLORCODE: "#F8FFE0",
      NAME: "Roberto Carlos",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
    {
      field: 3,
      COLORCODE: "#ADFF2F",
      NAME: "John Doe 2",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
    {
      field: 4,
      COLORCODE: "#000",
      NAME: "John Doe 2",
      EMAIL: "john@gmail.com",
      CONTACTNO: "01111998",
      DATE: "2025/03/05",
      TIME: "10:57 AM",
      AMOUNT: "LKR 20,000",
    },
  ],
  name: "Sample Details",
};

export const brandData: GridData = {
  columns: [
    { field: "brandcode", headerName: "Brand ID", width: 120, flex: 1 },
    { field: "brandname", headerName: "Brand Name", width: 120, flex: 1 },
    { field: "descrip", headerName: "Description", width: 200, flex: 1 },
  ],
  name: "Brand Details",
};

export const MainCatergorydata: GridData = {
  columns: [
    { field: "catcode", headerName: "Main Category ID", flex: 1, minWidth: 100 },
    { field: "catname", headerName: "Main Category", flex: 2, minWidth: 150 },
    { field: "descrip", headerName: "Description", flex: 3, minWidth: 200 },
  ],
  name: "Main Category Details",
};

export const Catergorydata: GridData = {
  columns: [
    { field: "catcode", headerName: "Category ID", width: 120, flex: 1 },
    { field: "catname", headerName: "Category Name", width: 120, flex: 1 },
    { field: "descrip", headerName: "Description", width: 200, flex: 1 },
  ],
  name: "Category Details",
};

export const subCatergorydata: GridData = {
  columns: [
    { field: "subcatcode", headerName: "Subcategory ID", width: 120, flex: 1 },
    { field: "subcatname", headerName: "Subcategory Name", width: 120, flex: 1 },
    { field: "descrip", headerName: "Description", width: 200, flex: 1 },
  ],
  name: "Subcategory Details",
};

export const Doctypedata: GridData = {
  columns: [
    {
      field: "doctype",
      headerName: "Document Type Name ",
      width: 120,
      flex: 1,
    },
  ],
  name: "Document Type Details",
};

export const Reasontypedata: GridData = {
  columns: [
    { field: "descrip", headerName: "Reason", width: 200, flex: 1 },
  ],
  name: "Reason Type Details",
};

export const Industrydata: GridData = {
  columns: [
    { field: "industryname", headerName: "industry Name", width: 120, flex: 1 },
  ],
  name: "Industry Details",
};

export const Supchargedata: GridData = {
  columns: [
    {
      field: "supchargetype",
      headerName: "Supplier Charge Type",
      width: 120,
      flex: 1,
    },
  ],
  name: "Supplier Charges",
};

export const chargedata: GridData = {
  columns: [
    { field: "chargetype", headerName: " Charge Type", width: 120, flex: 1 },
  ],
  name: " Charges",
};

export const warehousedata: GridData = {
  columns: [
    { field: "restname", headerName: "Warehouse", width: 150, flex: 1 },
  ],
  name: "Warehouse Details",
};

export const Bankdata: GridData = {
  columns: [
    { field: "bankname", headerName: "Bank Name", width: 120, flex: 1 },
    { field: "bankcode", headerName: "Bank Code", width: 120, flex: 1 },
  ],
  name: "Bank Details",
};

export const Branchdata: GridData = {
  columns: [
    { field: "branchname", headerName: "Branch Name", width: 120, flex: 1 },
    { field: "branchcode", headerName: "Branch Code", width: 120, flex: 1 },
  ],
  name: "Branch Details",
};

// Unit of Measurement Data (UOM)
export const MOUdata: GridData = {
  columns: [
    {
      field: "measuringunitcode",
      headerName: "UOM ID",
      width: 200,
      flex: 1,
    },
    {
      field: "immeasuringunit",
      headerName: "measuring Unit",
      width: 120,
      flex: 1,
    },
    { field: "descrip", headerName: "description", width: 200, flex: 1 },
  ],
  name: "Measuring Unit Details",
};

export const GenericNamedata: GridData = {
  columns: [
    { field: "genericcode", headerName: "Generic ID", flex: 1 },
    { field: "subcatname", headerName: "Subcategory", flex: 1 },
    { field: "genericname", headerName: "Generic Name", flex: 1 },
    { field: "descrip", headerName: "Description", flex: 2 },
  ],
  name: "Generic Name Details",
};

export const Packagedata: GridData = {
  columns: [
    { field: "packagecode", headerName: "package ID", width: 120, flex: 1 },
    { field: "packagename", headerName: "package name", width: 120, flex: 1 },
    { field: "descrip", headerName: "description", width: 200, flex: 1 },
  ],
  name: "Package Details",
};

export const Productdata: GridData = {
  columns: [
    { field: "productname", headerName: "product name", width: 120, flex: 1 },
    { field: "packagename", headerName: "package name", width: 120, flex: 1 },
    { field: "catname", headerName: "Category name", width: 200, flex: 1 },
    {
      field: "subcatname",
      headerName: " SubCategory name",
      width: 200,
      flex: 1,
    },
    { field: "brandname", headerName: "Brand name", width: 120, flex: 1 },
    {
      field: "minorderlevel",
      headerName: "Minimum Order Level",
      width: 200,
      flex: 1,
    },
    {
      field: "immeasuringunit",
      headerName: "measuring unit",
      width: 120,
      flex: 1,
    },
    { field: "descrip", headerName: "description", width: 200, flex: 1 },
  ],
  name: "Product Details",
};

export const advanceSearchData: GridData = {
  columns: [
    { field: "PONUMBER", headerName: "PO Number", flex: 1 },
    { field: "PODATE", headerName: "PO Date", flex: 1 },
    {
      field: "DELIVERYDATE",
      headerName: "Delivery Date",
      flex: 1,
    },
    {
      field: "DELIVERYLOCATION",
      headerName: "Delivery Location",
      flex: 1,
    },
  ],
  rows: [
    {
      field: 1,
      PONUMBER: "PO00007",
      PODATE: "22/21/2025",
      DELIVERYDATE: "22/21/2025",
      DELIVERYLOCATION: "Colombo",
    },
  ],
  name: "Sample Details",
};

export const grnPoSummary: GridData = {
  columns: [
    { field: "ITEMCODE", headerName: "Item Name", flex: 1 },
    { field: "ITEMNAME", headerName: "Item Name", flex: 1 },
    {
      field: "BRAND",
      headerName: "Brand",
      flex: 1,
    },
    {
      field: "UOM",
      headerName: "UOM",
      flex: 1,
    },
    {
      field: "POQUANTITY",
      headerName: "PO Quantity",
      flex: 1,
    },
  ],
  rows: [
    {
      field: 1,
      ITEMCODE: "PO00007",
      ITEMNAME: "Kiri Samba",
      BRAND: "Araliya",
      UOM: "KG",
      POQUANTITY: "1000",
    },
  ],
  name: "Sample Details",
};

// Variant data
export const Variantdata: GridData = {
  columns: [
    {
      field: "itemcode",
      headerName: "Item Code",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "itemname",
      headerName: "Item Name",
      flex: 2,
      minWidth: 150,
    },
    {
      field: "varianttype",
      headerName: "Variant Type",
      flex: 2,
      minWidth: 180,
    },
    {
      field: "createddate",
      headerName: "Created Date",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "uploadtype",
      headerName: "Upload Type",
      flex: 1,
      minWidth: 120,
    },
  ],
  name: "Item Variant Details",
};